import { emptyFn } from 'modules/common/utils/emptyFn';
import { useChainsProjects } from 'modules/chains/hooks/useChainsProjects';
import { useChainsSorting } from 'modules/chains/hooks/useChainsSorting';

import { usePrivateChainsList } from './usePrivateChainsList';
import { useChainsPrivateStats } from './useChainsPrivateStats';

export const usePrivateChains = () => {
  const {
    chains,
    loading: chainsLoading,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    timeframe,
  } = usePrivateChainsList();

  const {
    chainsCountsMap,
    loading: statsLoading,
    params: statsParams,
  } = useChainsPrivateStats({ timeframe });

  const {
    projects,
    projectsLoading,
    projectsWithChains,
    projectsWithChainsLoading,
  } = useChainsProjects();

  const { processedChains } = useChainsSorting({
    blockchainsCountsMap: chainsCountsMap,
    chains,
    searchContent,
    sortType,
    timeframe,
    isPublicChainsChecked: false,
  });

  return {
    loading:
      chainsLoading ||
      statsLoading ||
      projectsLoading ||
      projectsWithChainsLoading,
    processedChains,
    projects,
    projectsLoading,
    projectsWithChains,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    statsParams,
    timeframe,
    // added for compatibility with public chains list
    isPublicChainsChecked: false,
    onPublicChainsCheckboxClick: emptyFn,
  };
};
